// extracted by mini-css-extract-plugin
export default {"todoitem":"todoitem_b0c45f305922abb1255c","description":"description_e70e3385ce8d72b431f8"};